var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgStari = function SvgStari(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "m13.289 3.46 1.577 5.167h5.284a1.367 1.367 0 0 1 .818 2.449l-4.332 3.35 1.619 5.3a1.352 1.352 0 0 1-2.106 1.487l-4.148-3.207-4.149 3.207a1.352 1.352 0 0 1-2.105-1.486l1.619-5.3-4.332-3.35a1.367 1.367 0 0 1 .818-2.45h5.284l1.576-5.162a1.344 1.344 0 0 1 2.577-.005",
    "data-name": "Path 5143"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStari);
export default ForwardRef;